export function BackgroundPattern() {
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
            <div className="absolute inset-0 bg-hero" />
            <div className="absolute -left-32 top-24 h-72 w-72 rounded-full border border-white/25 opacity-40" />
            <div className="absolute -right-40 top-16 h-80 w-80 rounded-full border border-white/20 opacity-35" />
            <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-white/10 to-transparent" />
            <svg
                className="absolute left-0 top-1/2 h-64 w-64 -translate-y-1/2 text-white/25"
                viewBox="0 0 200 200"
                aria-hidden="true"
            >
                <circle cx="80" cy="100" r="70" stroke="currentColor" strokeWidth="2" fill="none" />
                <circle cx="80" cy="100" r="95" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.6" />
                <circle cx="80" cy="100" r="120" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.35" />
            </svg>
            <svg
                className="absolute right-0 top-1/3 h-64 w-64 -translate-y-1/2 text-white/20"
                viewBox="0 0 200 200"
                aria-hidden="true"
            >
                <circle cx="120" cy="100" r="70" stroke="currentColor" strokeWidth="2" fill="none" />
                <circle cx="120" cy="100" r="95" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.6" />
                <circle cx="120" cy="100" r="120" stroke="currentColor" strokeWidth="1" fill="none" opacity="0.35" />
            </svg>
            <svg
                className="absolute bottom-0 left-0 h-40 w-full text-white/20"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path
                    d="M0 80 C 150 20 300 140 450 80 C 600 20 750 140 900 80 C 1050 20 1200 140 1350 80"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                />
                <path
                    d="M0 100 C 150 40 300 160 450 100 C 600 40 750 160 900 100 C 1050 40 1200 160 1350 100"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    fill="none"
                    opacity="0.6"
                />
            </svg>
        </div>
    );
}
